module.exports = __webpack_public_path__ + "img/album08_08.492b06eb.jpg";